export const API_NAME = "strength";
export const ROUTE_NAME = "strength";
export const COMPONENT_NAMES = ["strength", "strengths"];
